/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Ismanuallyassigned2Inputs */

const en_entity_ismanuallyassigned2 = /** @type {(inputs: Entity_Ismanuallyassigned2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Manually Assigned`)
};

const de_entity_ismanuallyassigned2 = /** @type {(inputs: Entity_Ismanuallyassigned2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuell zugewiesen`)
};

/**
* | output |
* | --- |
* | "Is Manually Assigned" |
*
* @param {Entity_Ismanuallyassigned2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_ismanuallyassigned2 = /** @type {((inputs?: Entity_Ismanuallyassigned2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Ismanuallyassigned2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_ismanuallyassigned2(inputs)
	return de_entity_ismanuallyassigned2(inputs)
});
export { entity_ismanuallyassigned2 as "entity_isManuallyAssigned" }